export default function TablePagination({ count, page, rowsPerPage, onChangePage, onChangeRowsPerPage, screener }) {
    const firstPage = screener ? 1 : 0;
    const pageValue1 = screener ? page : (page + 1);
    const pageValue2 = screener ? (page - 1) : page;

    const isFirstPage = page === firstPage;
    const lastPage = ((pageValue1) * rowsPerPage) > count ? count : (pageValue1) * rowsPerPage;

    return <ul className="pagination font-weight-normal h7">
        <li className="pagination__item margin-right-0" data-testid="displayText" style={{fontWeight: 700}}>Display</li>
        <li className="pagination__item pagination__item margin-right-20">
            <select className="selectpicker span3 pagination-dropdown dropdown-trigger darkblue-500-text padding-10 block text-align-center cursor-pointer" value={rowsPerPage} onChange={onChangeRowsPerPage} data-testid="paginationPageDropdown">
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                {screener ? <option value={250}>250</option> : null}
            </select>
        </li>
        <li className="pagination__item margin-right-10">
            <a className={isFirstPage ? "grey-500-text" : "darkblue-500-text cursor-pointer"} style={isFirstPage ? { cursor: "default" } : null} href="" onClick={e => { e.preventDefault(); onChangePage(page - 1) }} data-testid="previousPageButton" aria-label="Go to previous page" title="Go to previous page">
                <i className="fas fa-chevron-left" style={{ fontSize: "11px" }} data-testid="previousPageIcon" aria-hidden="true"></i>
            </a>
        </li>
        <li className="pagination__item margin-right-20" data-testid="pageCountText">{isFirstPage ? (count ? 1 : 0) : (pageValue2 * rowsPerPage) + 1}-{lastPage} of {count}</li>
        <li className="pagination__item margin-right-0">
            <a className={count === lastPage ? "grey-500-text" : "darkblue-500-text cursor-pointer"} style={count === lastPage ? { cursor: "default" } : null} href="" onClick={e => { e.preventDefault(); onChangePage(page + 1) }} data-testid="nextPageButton" aria-label="Go to next page" title="Go to next page">
                <i className="fas fa-chevron-right" style={{ fontSize: "11px" }} data-testid="nextPageIcon" aria-hidden="true"></i>
            </a>
        </li>
    </ul>
}